import { CustomerRole } from '@/types';
import { OrderStatusType } from '@/types/gql/graphql';

export interface FilterSearchProps {
  [key: string]: string | number | number[] | null;
  beginDateAt: string | null;
  endDateAt: string | null;
  orderBy: string;
  createdBy: string;
  q: string;
  companyName: string;
  isShowMy: number;
  companyId: string;
  companyIds: number[];
  deliveryTypeStatus: string;
  processingStatus: string;
  releaseStatus: string;
  deliveryId: number;
  offset: any;
  first: any;
}

export interface FilterMoreProps {
  startValue?: string;
  endValue?: string;
  PlacedBy?: string;
  company?: string;
  orderStatus?: string | number;
  deliveryTypeStatus?: string;
  processingStatus?: string;
  releaseStatus?: string;
  deliveryId?: number;
  ID: number;
}

export const defaultSortKey = 'creationDate';

export const sortKeys = {
  poNumber: 'poNumber',
  totalIncTax: 'totalIncTax',
  status: 'status',
  placedBy: 'placedBy',
  createdAt: 'createdAt',
  deliveryTypeStatus: 'deliveryTypeStatus',
  processingStatus: 'processingStatus',
  creationDate: 'creationDate',
  deliveryType: 'deliveryType',
  releaseStatus: 'releaseStatus',
  ID: 'ID',
};

export const deliveryTypeStatus = [
  {
    key: 'standard',
    value: 'OB',
    label: 'deliveries.type.standard',
  },
  {
    key: 'consignmentFillUp',
    value: 'ODCF',
    label: 'deliveries.type.consignmentFillUp',
  },
  {
    key: 'consignmentIssue',
    value: 'ODCI',
    label: 'deliveries.type.consignmentIssue',
  },
  {
    key: 'returnSupplier',
    value: 'ODSH',
    label: 'deliveries.type.returnToSupplier',
  },
  {
    key: 'spareParts',
    value: 'ODSR',
    label: 'deliveries.type.spareParts',
  },
  {
    key: 'ReturnCustomer',
    value: 'ORTC',
    label: 'deliveries.type.returnToCustomer',
  },
  {
    key: 'overCounterSales',
    value: 'OTCS',
    label: 'deliveries.type.overTheCounterSales',
  },
  {
    key: 'stockTransfer',
    value: 'STOD',
    label: 'deliveries.type.stockTransfer',
  },
  {
    key: 'thirdParty',
    value: 'TPDO',
    label: 'deliveries.type.thirdParty',
  },
];

export const processingStatus = [
  {
    key: 'notStarted',
    value: '1',
    label: 'deliveries.processingStatus.notStarted',
  },
  {
    key: 'inProcess',
    value: '2',
    label: 'deliveries.processingStatus.inProcess',
  },
  {
    key: 'finished',
    value: '3',
    label: 'deliveries.processingStatus.finished',
  },
  {
    key: 'notRelevant',
    value: '4',
    label: 'deliveries.processingStatus.notRelevant',
  },
  {
    key: 'Interrupted',
    value: '5',
    label: 'deliveries.processingStatus.interrupted',
  },
];

export const releaseStatus = [
  {
    key: 'notReleased',
    value: 1,
    label: 'deliveries.releaseStatus.notReleased',
  },
  {
    key: 'Partially Released',
    value: 2, 
    label: 'deliveries.releaseStatus.partiallyReleased',
  },
  {
    key: 'released',
    value: 3,
    label: 'deliveries.releaseStatus.released',
  },
  {
    key: 'releaseDiscarded',
    value: 4,
    label: 'deliveries.releaseStatus.releaseDiscarded',
  },
  {
    key: 'releaseCanceled',
    value: 5,
    label: 'deliveries.releaseStatus.releaseCanceled',
  },
  {
    key: 'notRelevant',
    value: 6,
    label: 'deliveries.releaseStatus.notRelevant',
  },
  {
    key: 'releaseCancellationRequested',
    value: 7,
    label: 'deliveries.releaseStatus.releaseCancellationRequested',
  },
  {
    key: 'releaseRequested',
    value: 5,
    label: 'deliveries.releaseStatus.releaseRequested',
  },
];

const b2bFilterSearch: FilterSearchProps = {
  q: '',
  companyId: '',
  beginDateAt: null,
  endDateAt: null,
  companyName: '',
  orderBy: `-${sortKeys[defaultSortKey]}`,
  createdBy: '',
  orderNumber: '',
  poNumber: '',
  isShowMy: 0,
  companyIds: [],
  deliveryTypeStatus: '',
  processingStatus: '',
  releaseStatus: '',
  deliveryId: 0,
  offset: 0,
  first: 10,
};

const bcFilterSearch = {
  beginDateAt: null,
  creationDate: null,
  deliveryTypeStatus: '',
  processingStatus: '',
  releaseStatus: '',
  deliveryType: '',
  endDateAt: null,
  orderBy: `-${sortKeys[defaultSortKey]}`,
  createdBy: '',
  q: '',
  deliveryId: 0,
  ID: 0,
};

export const getFilterMoreData = (
  isB2BUser: boolean,
  role: string | number,
  isCompanyOrder: boolean,
  isAgenting: boolean,
  _createdByUsers: any,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _orderStatuses: OrderStatusType[] = [],
) => {
  // const newOrderStatuses = orderStatuses.filter(
  //   (item) => item.statusCode !== '0' && item.statusCode !== '1',
  // );
  // const newCreatedByUsers =
  //   createdByUsers?.createdByUser?.results.map((item: any) => ({
  //     createdBy: `${item.firstName} ${item.lastName} (${item.email})`,
  //   })) || [];
  const filterMoreList = [
    {
      name: 'deliveryId',
      label: 'Delivery ID',
      required: false,
      default: '',
      fieldType: 'text',
      xs: 12,
      variant: 'filled',
      size: 'small',
      idLang: 'deliveries.deliveryId',
    },
    {
      name: 'deliveryTypeStatus',
      label: 'Delivery Type',
      required: false,
      default: '',
      fieldType: 'dropdown',
      xs: 12,
      variant: 'filled',
      size: 'small',
      options: deliveryTypeStatus,
      idLang: 'deliveries.deliveryType',
    },
    {
      name: 'processingStatus',
      label: 'Processing Status',
      required: false,
      default: '',
      fieldType: 'dropdown',
      xs: 12,
      variant: 'filled',
      size: 'small',
      options: processingStatus,
      idLang: 'deliveries.processingStatus',
     },
    {
      name: 'releaseStatus',
      label: 'Release Status',
      required: false,
      default: '',
      fieldType: 'dropdown',
      xs: 12,
      variant: 'filled',
      size: 'small',
      options: releaseStatus,
      idLang: 'deliveries.releaseStatus',
    },
  ];

  const filterCondition = isB2BUser && !(Number(role) === 3 && !isAgenting);
  const filterCurrentMoreList = filterMoreList.filter((item) => {
    if (
      (!isB2BUser || filterCondition) &&
      !isCompanyOrder &&
      (item.name === 'company' || item.name === 'PlacedBy')
    )
      return false;
    if (Number(role) === 3 && !isAgenting && item.name === 'PlacedBy') return false;
    if (
      (isB2BUser || (Number(role) === CustomerRole.SUPER_ADMIN && isAgenting)) &&
      isCompanyOrder &&
      item.name === 'company'
    )
      return false;
    return true;
  });

  return filterCurrentMoreList;
};

export const getInitFilter = (
  isCompanyOrder: boolean,
  isB2BUser: boolean,
): Partial<FilterSearchProps> => {
  if (isB2BUser) b2bFilterSearch.isShowMy = isCompanyOrder ? 0 : 1;

  return isB2BUser ? b2bFilterSearch : bcFilterSearch;
};

export const currencySymbol = (currencyItem: string) => {
  try {
    if (currencyItem) {
      const currencyToken = JSON.parse(JSON.parse(currencyItem))?.currency_token || '';

      return currencyToken;
    }

    return '';
  } catch (e) {
    return '';
  }
};

export const filterFormConfigsTranslationVariables: { [key: string]: string } = {
 
  standard: 'deliveries.type.standard',
  consignmentFillUp: 'deliveries.type.consignmentFillUp',
  consignmentIssue: 'deliveries.type.consignmentIssue',
  returnSupplier: 'deliveries.type.returnToSupplier',
  spareParts: 'deliveries.type.spareParts',
  ReturnCustomer: 'deliveries.type.returnToCustomer',
  overCounterSales: 'deliveries.type.overTheCounterSales',
  stockTransfer: 'deliveries.type.stockTransfer',
  thirdParty: 'deliveries.type.thirdParty',
  
  notStarted: 'deliveries.processingStatus.notStarted',
  inProcess: 'deliveries.processingStatus.inProcess',
  finished: 'deliveries.processingStatus.finished',
  notRelevant: 'deliveries.processingStatus.notRelevant',
  Interrupted: 'deliveries.processingStatus.interrupted',

  notReleased: 'deliveries.releaseStatus.notReleased',
  "Partially Released": 'deliveries.releaseStatus.partiallyReleased',
  released: 'deliveries.releaseStatus.released',
  releaseDiscarded: 'deliveries.releaseStatus.releaseDiscarded',
  releaseCanceled: 'deliveries.releaseStatus.releaseCanceled',
  releaseCancellationRequested: 'deliveries.releaseStatus.releaseCancellationRequested',
  releaseRequested: 'deliveries.releaseStatus.releaseRequested',
};


export const getOrderStatusText = (status: number | string, getOrderStatuses: any) =>
  getOrderStatuses.find((item: any) => item.systemLabel === status)?.customLabel || '';
